// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['lt_LT']  = {
  "name": "lt_LT",
  "day": {
    "abbrev": [
      "Sk",
      "Pr",
      "An",
      "Tr",
      "Kt",
      "Pn",
      "Št"
    ],
    "full": [
      "Sekmadienis",
      "Pirmadienis",
      "Antradienis",
      "Trečiadienis",
      "Ketvirtadienis",
      "Penktadienis",
      "Šeštadienis"
    ]
  },
  "month": {
    "abbrev": [
      "Sau",
      "Vas",
      "Kov",
      "Bal",
      "Geg",
      "Bir",
      "Lie",
      "Rgp",
      "Rgs",
      "Spa",
      "Lap",
      "Grd"
    ],
    "full": [
      "sausio",
      "vasario",
      "kovo",
      "balandžio",
      "gegužės",
      "birželio",
      "liepos",
      "rugpjūčio",
      "rugsėjo",
      "spalio",
      "lapkričio",
      "gruodžio"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%Y.%m.%d",
  "time24": "%T",
  "dateTime": "%Y m. %B %d d. %T",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

